/**
 * Duplicated in src/sw.js, which is a raw asset and so cannot import from here.
 * Changing one side without the other breaks the bell silently.
 */
export const PUSH_MESSAGE = 'triggerbee-push';
export const CLICK_MESSAGE = 'triggerbee-notification-click';
export const SUBSCRIPTION_CHANGE_MESSAGE = 'triggerbee-push-subscription-change';

/**
 * What the toggle can be in, ordered from "do not offer this at all" to "on".
 *
 * `on` means the server has been told, this page load. Not "the browser holds a subscription object": that
 * distinction is what makes a failed subscribe POST read as off rather than as on.
 */
export type WebPushState =
  | 'unsupported'
  | 'insecureContext'
  /** No VAPID key in this environment, which arrives as a 204. Offer nothing and say nothing. */
  | 'notConfigured'
  | 'blocked'
  | 'promptRequired'
  | 'off'
  | 'on'
  /** Before the first probe resolves. Renders nothing. */
  | 'probing';

export interface PushHint {
  eventId: string;
  notificationType: string;
}

export interface PushMessage {
  type: typeof PUSH_MESSAGE;
  eventId: string;
  notificationType: string;
}

export interface ClickMessage {
  type: typeof CLICK_MESSAGE;
  eventId: string;
}

export interface SubscriptionChangeMessage {
  type: typeof SUBSCRIPTION_CHANGE_MESSAGE;
  oldEndpoint: string;
}

export type WorkerMessage = PushMessage | ClickMessage | SubscriptionChangeMessage;
